import { Component } from '@angular/core'
import { InfoBoxComponent } from './info-box/info-box.component'
import { ResultManagerComponent } from './result-manager/result-manager.component'

@Component({
  selector: 'app-results-tab',
  templateUrl: './results-tab.component.html',
  imports: [
    // Components
    InfoBoxComponent,
    ResultManagerComponent,
  ],
})
export class ResultsTabComponent {}
